import type { ScreenModule } from "../../../app/screen-module";
import { PricingPage } from "../pages";

export default {
	id: "public.pricing",
	path: "/pricing",
	area: "public",
	navGroup: "サービス案内",
	label: "料金",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: PricingPage,
} satisfies ScreenModule;
